'use client';
/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/react';
import Typography from '@egalite/ui/Typography';
import { InputField } from '@egalite/ui/Form';
import ButtonsPages from './legacy_blocks/ButtonsPages';
import useForm from '../../lib/hooks/useForm';
import validationSchema, { initialValues } from '../../lib/validation/candidate/professionalData1';
import FormPage from './legacy_blocks/CandidateFormPage';
import { useState, useEffect, useRef, useCallback, FC } from 'react';
import Loading from '@egalite/ui/Loading';
import save from './save';
import { useNotification } from '@egalite/ui/IncluiPCD/NotificationProvider';
import { useRouter } from 'next/navigation';
import authFetch from '../../lib/auth/authFetch';
import Cookies from 'js-cookie';
import Button from '@egalite/ui/Buttons';

const ProfessionalData1Form: FC<{ edit?: boolean; onSuccess?: () => void }> = ({ edit = false, onSuccess = null }) => {
	const notification = useNotification();
	const [loadingData, setLoadingData] = useState(true);
	const [candidateData, setCandidateData] = useState(initialValues);

	const router = useRouter();

	const [formController, getFieldProps, { loading, submitting, success, errors, data }] = useForm({
		initialValues: candidateData,
		validationSchema,
		mutation: data => save('/api/v1/candidate/professionalData1', data),
		onSuccess:
			onSuccess != null
				? () => onSuccess()
				: () => {
						router.push(`/candidato/form/professionalData2`, { scroll: true });
				  },
	});
	useEffect(() => {
		if (loadingData) {
			authFetch('/api/v2/candidate/profile', Cookies.get('token'))
				.then(res => res.json())
				.then(data => {
					if (data.success === true) {
						const newValues = Object.keys(initialValues).reduce((acc, key) => {
							acc[key] = data.data[key] ?? initialValues[key];
							return acc;
						}, {});
						setCandidateData(newValues as typeof initialValues);
						setLoadingData(false);
					} else {
						notification.error('Erro ao carregar dados do candidato');
					}
				});
		}
	}, [formController, router, loadingData, notification]);

	if (loadingData) {
		return <Loading fullScreen={true}>carregando dados</Loading>;
	}

	return (
		<FormPage
			actualStep={3}
			formActualStep={1}
			formTotalSteps={5}
			progress={20}
			formTitle={'Dados profissionais'}
			// previousForm="/"
			showStepsMenu={false}
			// showBackButton={false}
			modal={edit}
		>
			<form onSubmit={formController.handleSubmit}>
				<div className="mb-16 md:mb-24">
					<InputField
						id="salaryRequirement.value"
						type="text"
						maskOptions={{
							mask: 'R$ num',
							lazy: false,
							blocks: {
								num: {
									mask: Number,
									normalizeZeros: false,
									padFractionalZeros: true,
									thousandsSeparator: '.',
									radix: ',',
									mapToRadix: [','],
									scale: 0,
								},
							},
						}}
						label={'Pretensão Salarial'}
						{...getFieldProps('salaryRequirement.value')}
					/>
					<Typography variant="body2">
						A pretensão salarial é o valor mínimo que você gostaria de receber de salário por mês.
					</Typography>

					

					<InputField id="linkedin" type="text" label="Linkedin" {...getFieldProps('linkedin')} />

					{/* <ErrorList errors={formController.errors} touched={formController.touched} /> */}
					{Array.isArray(errors) &&
						errors.map((err, index) => (
							<Typography key={`err-${index}`} variant="body2" color="error.dark">
								{err}
							</Typography>
						))}
					<div className="md:mt-24 mt-16">
						{edit ? (
							<Button type="submit" variant="primary" className="w-full">
								Salvar
							</Button>
						) : (
							<ButtonsPages previousForm={'/candidato/form/personalData2'} submitDisabled={submitting} />
						)}
					</div>
				</div>
			</form>
		</FormPage>
	);
};

export default ProfessionalData1Form;
